import { coreTranslations } from 'translations';
import featureService from '@services/feature.service';
import isMobileAppView from 'common/utility/isMobileAppView';

export const alertModuleConfig = [
    {
        id: 'labels',
        title: coreTranslations.ng_core_labels,
        description: coreTranslations.ng_core_customLabelsDescription,
        path: featureService.getFeature('protectedFields') ? '/labels/overview' : '/labels',
        visible: access => access.canOrganizationAdmin()
    },
    {
        id: 'alert-options',
        title: coreTranslations.ng_core_alertOptions,
        description: coreTranslations.ng_core_alertOptionsDescription,
        path: {
            redirectTo: '/res/organization/editNotificationOptions.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewAlertOptions() && featureService.getFeature('mir3Redirects') && !isMobileAppView()
    },
    {
        id: 'division-ani',
        title: coreTranslations.ng_core_division_ani,
        description: coreTranslations.ng_core_divisionAniDescription,
        path: {
            redirectTo: '/prepareAni.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewDivisionANI() && featureService.getFeature('mir3Redirects') && !isMobileAppView()
    },
    {
        id: 'call-tThrottling',
        title: coreTranslations.ng_core_call_throttling,
        description: coreTranslations.ng_core_callThrottlingDescription,
        path: {
            redirectTo: '/preparePhonePrefixes.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewCallThrottling() && featureService.getFeature('mir3Redirects') && !isMobileAppView()
    },
    {
        id: 'suppressed-alerts',
        title: coreTranslations.ng_core_suppressedAlerts,
        description: coreTranslations.ng_core_suppressedAlertsDescription,
        path: {
            redirectTo: '/prepareDuplicateSuppressionReport.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewSuppressedAlert() && !isMobileAppView() && !access.usesNextGenSendingEngine()
    },
    {
        id: 'manage-blocked-SMS',
        title: coreTranslations.ng_core_manageBlockedSMS,
        description: coreTranslations.ng_core_manageBlockedSMSDescription,
        path: {
            redirectTo: '/res/organization/block-sms.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewManageBlockedSMS()
    },
    {
        id: 'allowedSMS',
        title: coreTranslations.ng_core_allowedSMS,
        description: coreTranslations.ng_core_allowedSMSDescription,
        path: {
            redirectTo: '/prepareReactivateSMS.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewAllowedSMS() && !isMobileAppView()
    },
    {
        id: 'assignSMSProfiles',
        title: coreTranslations.ng_core_assignSMSProfiles,
        description: coreTranslations.ng_core_assignSMSProfilesDescription,
        path: {
            redirectTo: '/res/organization/assign-sms-profile.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewAssignSmsProfiles()
    },
    {
        id: 'editTTSVoices',
        title: coreTranslations.ng_core_editTTSVoices,
        description: coreTranslations.ng_core_editTTSVoicesDescription,
        path: {
            redirectTo: '/prepareTTS.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewEditTSSVoices() && !isMobileAppView()
    },
    {
        id: 'editPronunciations',
        title: coreTranslations.ng_core_editPronunciations,
        description: coreTranslations.ng_core_editPronunciationsDescription,
        path: {
            redirectTo: '/preparePronunciation.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canEditPronunciation() && !isMobileAppView()
    },
    {
        id: 'duplicateFilters',
        title: coreTranslations.ng_core_duplicateFilters,
        description: coreTranslations.ng_core_duplicateFiltersDescription,
        path: {
            redirectTo: '/res/notification/duplicate-filters.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewDuplicateFilters() && !isMobileAppView()
    },
    {
        id: 'alertRetrieval',
        title: coreTranslations.ng_core_alertRetrieval,
        description: coreTranslations.ng_core_alertRetrievalDescription,
        path: {
            redirectTo: '/prepareNotificationRetrieval.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access => access.canViewAlertRetrieval() && !isMobileAppView()
    }
];
